import templateUrl from './days-of-operation.html';
import mapKeys from 'lodash/mapKeys';
import size from 'lodash/size';

export const daysOfOperationComponent = {
	templateUrl,

	bindings: {
		providerName: '@',
		details: '<',
		key: '@'
	},

	controller: class DaysOfOperationComponent {
		//***********************************************Public Methods***************************************************** */
		$onInit() {
			this.details = this._getDaysOfWeekByOrder(this.details);
		}

		//***********************************************Private Methods***************************************************** */
		_getADATextForSingleDay(day) {
			return `${this.providerName || 'provider '}${this.details[day] ? 'provide' : 'do not provide'} service on ${day}`;
		}

		_getADAText() {
			let ADAText = [`${this.providerName || 'provider'} provide service on `];
			let availableDays = this._getAvailableAndNotAvailableDays(true);
			let notAvailableDays = this._getAvailableAndNotAvailableDays(false);
			
			ADAText = [...ADAText, availableDays];
			ADAText = size(notAvailableDays) > 0 ? [...ADAText, 'and not available on ', notAvailableDays] : ADAText;
			
			return ADAText.join(',');
		}

		_getAvailableAndNotAvailableDays(isAvailable) {
			let days = [];

			mapKeys(this.details,(value, key) => {
				if(value === isAvailable) {
					days.push(key);
				}
			});

			return days;
		}

		_getDaysOfWeekByOrder({monday,tuesday,wednesday,thursday,friday,saturday,sunday}) {
			return {
				monday,
				tuesday,
				wednesday,
				thursday,
				friday,
				saturday,
				sunday
			};
		}

		_getClass(day) {
			return this.details && day ? this.details[day] === true ? 'activeDay' : 'inActiveDay' : '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/days-of-operation/days-of-operation.component.js